import { useId, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { HexColorPicker } from "react-colorful";

interface ColorPickerProps {
  color: string;
  onChange: (color: string) => void;
  label: string;
}

export function ColorPicker({ color, onChange, label }: ColorPickerProps) {
  const [open, setOpen] = useState(false);
  const inputId = useId();

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={inputId}>{label}</Label>
      <div className="flex min-w-0 gap-2">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className="size-11 shrink-0 p-0"
              style={{ backgroundColor: color }}
              aria-label={`Choose ${label.toLowerCase()}`}
            />
          </PopoverTrigger>
          <PopoverContent className="w-auto p-3">
            <div>
              <HexColorPicker color={color} onChange={onChange} />
            </div>
          </PopoverContent>
        </Popover>
        <Input
          id={inputId}
          value={color}
          onChange={(e) => onChange(e.target.value)}
          className="min-w-0 flex-1 font-mono uppercase"
          spellCheck={false}
        />
      </div>
    </div>
  );
}
